export default "__VITE_ASSET__CHb2_Dck__"